import React from "react";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { UxAction, UxIconEnum, UxSizeEnum, UxShadesEnum, UxPriorityEnum, UxIconLibraryEnum } from "@imaginelearning/mps-ux-component-library";
import TranslationDropdown from "../translation-dropdown/translation-dropdown";
function Actions(props) {
    var show = props.show, hintCallback = props.hintCallback, closeCallback = props.closeCallback, vocabCallback = props.vocabCallback, textToSpeechCallback = props.textToSpeechCallback, selectedLanguage = props.selectedLanguage, languageChangeCallback = props.languageChangeCallback, ariaLabel = props.ariaLabel, calculatorCallback = props.calculatorCallback, calculatorTooltip = props.calculatorTooltip;
    var handleClick = function () {
        // tslint:disable-next-line:no-console
        console.log("button clicked");
    };
    return (React.createElement(React.Fragment, null,
        show.TextToSpeech && (React.createElement(UxAction, { enabled: true, priority: UxShadesEnum.LIGHT, callback: textToSpeechCallback, icon: {
                title: "Text to speech",
                icon: UxIconEnum.TEXT_TO_SPEECH,
                size: UxSizeEnum.LARGE,
                library: UxIconLibraryEnum.SOLID,
                className: "tts-icon text-primary"
            }, ariaLabel: ariaLabel })),
        show.Transcript && (React.createElement(UxAction, { enabled: true, priority: UxShadesEnum.LIGHT, callback: handleClick, icon: {
                title: "Transcript",
                icon: UxIconEnum.BOOK_READER,
                size: UxSizeEnum.LARGE
            } })),
        show.Help && (React.createElement(UxAction, { enabled: true, priority: UxShadesEnum.LIGHT, callback: handleClick, icon: {
                title: "Help",
                icon: UxIconEnum.WRENCH,
                size: UxSizeEnum.LARGE
            } })),
        show.Vocab && (React.createElement(UxAction, { enabled: true, priority: UxShadesEnum.LIGHT, callback: vocabCallback, icon: {
                title: "Vocabulary",
                icon: UxIconEnum.BOOK,
                size: UxSizeEnum.LARGE,
                library: UxIconLibraryEnum.DUOTONE,
                className: "text-primary"
            } })),
        show.Hint && (React.createElement(UxAction, { enabled: true, priority: UxShadesEnum.LIGHT, callback: hintCallback, icon: {
                title: "Hint",
                icon: UxIconEnum.LIGHTBULB_ON,
                size: UxSizeEnum.LARGE,
                library: UxIconLibraryEnum.DUOTONE,
                className: "text-primary"
            } })),
        show.Language && (React.createElement(TranslationDropdown, { languageChangeCallback: languageChangeCallback, languageSelected: selectedLanguage })),
        show.Close && (React.createElement(UxAction, { enabled: true, priority: UxPriorityEnum.INFO, callback: closeCallback, icon: {
                title: "Close",
                icon: UxIconEnum.TIMES,
                size: UxSizeEnum.LARGE
            }, className: "me-n3 close-btn", ariaLabel: ariaLabel })),
        show.Calculator && (React.createElement(OverlayTrigger, { key: "top", placement: "top", overlay: React.createElement(Tooltip, { id: "tooltip-top" }, calculatorTooltip || "") },
            React.createElement("div", null,
                React.createElement(UxAction, { enabled: true, priority: UxShadesEnum.LIGHT, callback: calculatorCallback, icon: {
                        title: "Calculator",
                        icon: UxIconEnum.CALCULATOR_ALT,
                        size: UxSizeEnum.LARGE,
                        library: UxIconLibraryEnum.SOLID,
                        className: "calculator-icon text-primary"
                    }, ariaLabel: ariaLabel, className: "calculator-btn" }))))));
}
export default Actions;
